import React from 'react';
import { Radio } from '@mui/material';

/** Lets Apply column read selection without closing over `selectedTaskRowId` in `columns` useMemo. */
export const ModsLinkTaskSelectionContext = React.createContext<{
  selectedTaskRowId: string | null;
  onSelectTask: (row: any) => void;
} | null>(null);

export const ModsLinkTaskApplyRadioCell: React.FC<{ gridRowId: string | number; row: any }> = ({
  gridRowId,
  row,
}) => {
  const ctx = React.useContext(ModsLinkTaskSelectionContext);
  if (!ctx) {
    return null;
  }
  const { selectedTaskRowId, onSelectTask } = ctx;
  return (
    <Radio
      checked={selectedTaskRowId === String(gridRowId)}
      onClick={event => {
        event.stopPropagation();
        onSelectTask(row);
      }}
    />
  );
};
